var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.998,
    height: 19.998,
    viewBox: "0 0 19.998 19.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(-3 -1)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_43654",
    "data-name": "Path 43654",
    d: "M20.776,18.776H3V21H20.776ZM22.665,2.933l-1.6-1.6a1.127,1.127,0,0,0-1.6,0l-.911.911,3.2,3.2.911-.911a1.127,1.127,0,0,0,0-1.6ZM10.644,16.554l.133-.133-3.2-3.2-.133.133v3.2ZM8.555,12.243l3.2,3.2,9.021-9.021-3.2-3.2Z",
    transform: "translate(0 0)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIcon);
export default __webpack_public_path__ + "static/media/editIcon.3a169d80dba1082fbf30af137e598efb.svg";
export { ForwardRef as ReactComponent };